import { useEffect } from 'react';

export interface TenantBranding {
  tenant_id: string;
  logo_url?: string | null;
  primary_color: string;
  accent_color: string;
  candidate_name?: string | null;
  party?: string | null;
  slogan?: string | null;
  app_name: string;
  /** Sigla do estado (ex: AL, SP). Determina o zoom inicial do mapa. */
  uf?: string | null;
  /** Nome do município do candidato. Geocodificado para centrar o mapa. */
  municipio?: string | null;
}

interface BrandingStyleInjectorProps {
  branding: TenantBranding;
}

export function BrandingStyleInjector({ branding }: BrandingStyleInjectorProps) {
  useEffect(() => {
    const root = document.documentElement;
    if (branding.primary_color) {
      root.style.setProperty('--color-primary', branding.primary_color);
    }
    if (branding.accent_color) {
      root.style.setProperty('--color-accent', branding.accent_color);
    }
    
    // Atualiza o título do documento dinamicamente
    if (branding.app_name) {
      const originalTitle = document.title;
      document.title = branding.app_name;
      
      return () => {
        document.title = originalTitle;
      };
    }
  }, [branding]);

  return null;
}
